import React from "react";
import "./about.css";
import Me from "../../assets/aboutMe.png";
import { FaAward, FaUniversity, FaFolder } from "react-icons/fa";
const About = () => {
  return (
    <section id="about">
      <h5>Get To Know</h5>
      <h2>About Me</h2>
      <div className="container about_container">
        <div className="about__me">
          <div className="about__me-image">
            <img src={Me} alt="aboutimage" />
          </div>
        </div>
        <div className="about__content">
          <div className="about__cards">
            <article className="about__card">
              <FaAward className="about__icon" />
              <h5>Experience</h5>
              <small>1 Years Working</small>
            </article>
            <article className="about__card">
              <FaUniversity className="about__icon" />
              <h5>Education</h5>
              <small>National University of Uzbekistan</small>
            </article>
            <article className="about__card">
              <FaFolder className="about__icon" />
              <h5>Projects</h5>
              <small>5+ Completed</small>
            </article>
          </div>
          <p>
            Assalamu aleykum My name is Yusupov Jaloliddin I was born in 1999 in
            Karakul district of Bukhara region. From 2015 to 2018 I studied at
            the Karakul Academic Lyceum. In 2018 I entered the Faculty of
            Mathematics of the National University of Uzbekistan. I am
            interested in Mathematics and Programming.
          </p>
          <a href="#contact" className="btn btn-primary">
            Let's Talk
          </a>
        </div>
      </div>
    </section>
  );
};

export default About;
